import { ALL_CHANNELS } from "../constants/Channels";
import { WHATSAPP } from "../constants/Channels";
import { TAKE_AWAY } from "../constants/OrderTypes";
import { DELIVERY } from "../constants/OrderTypes";
import { HOME_DELIVERY } from "../constants/OrderTypes";

export const state = () => ({
  recieverSettings: {},
  orders: [],
  orderDetails: {},
  cancelledOrders: [],
  cancelledOrdersTempList: null,
  onHoldOrders: [],
  selectedChannel: ALL_CHANNELS,
  orderDetailsLoading: false,
  socketDetails: {}
});

export const mutations = {
  SET_RECIEVER_SETTINGS(state, recieverSettings) {
    state.recieverSettings = recieverSettings;
  },
  SET_ORDERS(state, orders) {
    state.orders = orders.filter((order) => {
      return (
        order.order_type === HOME_DELIVERY.id ||
        order.order_type === DELIVERY.id ||
        order.order_type === TAKE_AWAY.id
      );
    });
  },
  SET_CANCELLED_ORDERS_TEMP_LIST(state, cancelledOrdersTempList) {
    state.cancelledOrdersTempList = cancelledOrdersTempList.filter((order) => {
      return (
        order.order_type === HOME_DELIVERY.id ||
        order.order_type === DELIVERY.id ||
        order.order_type === TAKE_AWAY.id
      );
    });
  },
  SET_ONHOLD_ORDERS(state, onHoldOrders) {
    state.onHoldOrders = onHoldOrders.filter((order) => {
      return (
        order.order_type === HOME_DELIVERY.id ||
        order.order_type === DELIVERY.id ||
        order.order_type === TAKE_AWAY.id
      );
    });
  },
  ADD_NEW_ORDER(state, order) {
    const index = state.orders.findIndex((el) => el.id == order.id);
    if (index >= 0) {
      state.orders[index] = order;
    } else {
      state.orders.unshift(order);
    }
  },
  ADD_NEW_CANCELLED_ORDER(state, order) {
    // const found = state.cancelledOrders.find(el => el.id == order.id);
    // if (!found) {
    state.cancelledOrders.push(order);
    const index = state.orders.findIndex((el) => el.id == order.id);
    if (index >= 0) {
      state.orders.splice(index, 1);
    }
    // }
  },
  REMOVE_CANCELLED_ORDER(state, index) {
    if (index === "all") {
      state.cancelledOrders.length = 0;
    } else {
      state.cancelledOrders.splice(index, 1);
    }
  },
  REMOVE_CANCELLED_ORDER_BY_ID(state, id) {
    const index = state.cancelledOrders.findIndex((el) => el.id === id);
    mutations.REMOVE_CANCELLED_ORDER(state, index);
  },
  SET_ORDER_DETAIL(state, orderDetails) {
    state.orderDetails = orderDetails;
  },
  SET_SELECTED_CHANNEL(state, selectedChannel) {
    state.selectedChannel = selectedChannel;
  },
  SET_ORDER_DETAILS_LOADING(state, orderDetailsLoading) {
    state.orderDetailsLoading = orderDetailsLoading;
  },
  SET_SOCKET_DETAILS(state, socketDetails) {
    state.socketDetails = socketDetails;
  }
};

export const actions = {
  clearRecieverData({ commit }) {
    commit("SET_ORDERS", []);
    commit("SET_ORDER_DETAIL", {});
  },
  patchLocationState({ dispatch, commit, state }, payload) {
    const locationId = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/locations/${locationId}/store_action`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          $nuxt.$store.dispatch("restaurant/getLocationDetails", false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          // commit("SET_RESTAURANT_INFO_LOADING", false);
        });
    });
  },
  patchRestaurantState({ dispatch, commit, state }, { payload, id }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/restaurants/${id}/store_action`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          $nuxt.$store.dispatch("restaurant/getLocationDetails", false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          // commit("SET_RESTAURANT_INFO_LOADING", false);
        });
    });
  },
  patchChannelState(
    { dispatch, commit, state },
    { payload, id, restaurantId }
  ) {
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/restaurants/${restaurantId}/restaurant_platforms/${id}/store_action`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          $nuxt.$store.dispatch("restaurant/getLocationDetails", false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          // commit("SET_RESTAURANT_INFO_LOADING", false);
        });
    });
  },
  patchRecieverSettings({ dispatch, commit, state }, payload) {
    const restaurantId = $nuxt.$ls.get("selected-restaurant-id");
    // commit("SET_RESTAURANT_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/restaurants/${restaurantId}/linked_apps/${state.recieverSettings.id}/satellite_app_action`,
          payload
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          // commit("SET_RESTAURANT_INFO_LOADING", false);
        });
    });
  },
  getOrders({ dispatch, commit, state, rootState }, data) {
    const locationId =
      rootState.restaurant?.locationDetails?.id ||
      $nuxt.$ls.get("selected-location-id");
    // commit("SET_RESTAURANT_INFO_LOADING", true);
    if (locationId) {
      return new Promise((resolve, reject) => {
        this.$axios
          .get(`/locations/${locationId}/orders`, {
            params: { kot_pending: true, platform: "web" },
            ...$nuxt.$configData?.apiV2Config
          })
          .then(function (response) {
            if (response.status === 200 && response.data.orders) {
              resolve(response);
              commit("SET_ORDERS", response.data.orders.live);
              commit("SET_ONHOLD_ORDERS", response.data.orders.on_hold || []);
              if (data && data.handleCancelledOrders) {
                commit(
                  "SET_CANCELLED_ORDERS_TEMP_LIST",
                  response.data.orders.cancelled || []
                );
              }
            }
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {});
      });
    }
  },
  getOrderDetails({ dispatch, commit }, { orderId, silent }) {
    if (!silent) {
      commit("SET_ORDER_DETAILS_LOADING", true);
    }
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/orders/${orderId}`, { ...$nuxt.$configData?.apiV2Config })
        .then(function (response) {
          if (response.status === 200 && response.data) {
            commit("SET_ORDER_DETAIL", response.data);
          }
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit("SET_ORDER_DETAIL", {});
        })
        .finally(() => {
          commit("SET_ORDER_DETAILS_LOADING", false);
        });
    });
  },
  getOrderDetailsObj({ dispatch, commit }, { orderId }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/orders/${orderId}`, { ...$nuxt.$configData?.apiV2Config })
        .then(function (response) {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  patchOrderStatus({ dispatch, commit }, { orderId, payload }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/orders/${orderId}/status`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(async function (response) {
          await dispatch("getOrders");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  cancelAndAssignNewRider({ dispatch, commit }, { orderId, payload }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/orders/${orderId}/create_new_rider`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(async function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  postRiderTemperature({ dispatch, commit }, { orderId, payload }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/orders/${orderId}/rider_temperature`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  // getSocketDetails({ dispatch, commit }, id) {
  //   id = id || $nuxt.$ls.get("selected-restaurant-id");
  //   return new Promise((resolve, reject) => {
  //     this.$axios
  //       .post(`/restaurants/${id}/sockets/live-orders`)
  //       .then(async function (response) {
  //         if (response.data.status === "success" && response.data.data) {
  //           commit("SET_SOCKET_DETAILS", response.data.data);
  //         }
  //         resolve(response);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       })
  //       .finally(() => {});
  //   });
  // },
  // updatePrintStatus({ dispatch, commit }, data) {
  //   const id = $nuxt.$ls.get("selected-restaurant-id");
  //   return new Promise((resolve, reject) => {
  //     this.$axios
  //       .post(
  //         `/restaurants/${id}/orders/${data.order.id}/update-print-status`,
  //         data.obj
  //       )
  //       .then(async function (response) {
  //         if (response.data.status === "success" && response.data.data) {
  //           commit("SET_SOCKET_DETAILS", response.data.data);
  //         }
  //         resolve(response);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       })
  //       .finally(() => {});
  //   });
  // },
  markOrderAsComplete({ dispatch, commit }, { orderId }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/orders/${orderId}/mark_complete`,
          {},
          $nuxt.$configData?.apiV2Config
        )
        .then(async function (response) {
          await dispatch("getOrders");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  markItemOutOfStock({ dispatch, commit }, { orderId, payload }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/orders/${orderId}/modify`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(async function (response) {
          await dispatch("getOrders");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  cancelOrderAcknowledge({}, { orderId }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/orders/${orderId}/acknowledge_cancelled_order`,
          {},
          $nuxt.$configData?.apiV2Config
        )
        .then(async function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  }
};

export const getters = {
  getOrderById(state) {
    return function (orderId) {
      return state.orders.find((order) => order.id === orderId);
    };
  },
  getSelectedChannelAllOrders(state) {
    return state.selectedChannel.name == ALL_CHANNELS.name
      ? state.orders
      : state.orders.filter((order) => {
          return order.source == state.selectedChannel.name;
        });
  },
  getChannelAllOrders(state) {
    return function (channel) {
      return channel == ALL_CHANNELS.name
        ? state.orders
        : state.orders.filter((order) => {
            return order.source == channel;
          });
    };
  },
  getSelectedChannelNewOrders(state) {
    return state.orders.filter((order) => {
      return (
        (state.selectedChannel.name == ALL_CHANNELS.name ||
          order.source == state.selectedChannel.name) &&
        order.status == $nuxt.$constants.OrderStatuses.NEW_ORDER.id
      );
    });
  },
  getAllChannelNewOrders(state) {
    return state.orders.filter((order) => {
      return order.status == $nuxt.$constants.OrderStatuses.NEW_ORDER.id;
    });
  },

  getSelectedChannelPreparingOrders(state) {
    return state.orders.filter((order) => {
      return (
        (state.selectedChannel.name == ALL_CHANNELS.name ||
          order.source == state.selectedChannel.name) &&
        order.status == $nuxt.$constants.OrderStatuses.PREPARING.id
      );
    });
  },
  getSelectedChannelReadyForDeliveryOrders(state) {
    return state.orders.filter((order) => {
      return (
        (state.selectedChannel.name == ALL_CHANNELS.name ||
          order.source == state.selectedChannel.name) &&
        order.status == $nuxt.$constants.OrderStatuses.READY_FOR_DELIVERY.id
      );
    });
  },
  getSelectedChannelPickedUpOrders(state) {
    return state.orders.filter((order) => {
      return (
        (state.selectedChannel.name == ALL_CHANNELS.name ||
          order.source == state.selectedChannel.name) &&
        order.status == $nuxt.$constants.OrderStatuses.PICKED_UP.id &&
        order.source !== "satellite"
      );
    });
  },
  isWhatsappAdded() {
    return $nuxt.$store.getters["restaurant/getLocationChannels"].some(
      (el) => el.name === WHATSAPP.name
    );
  },
  getWhatsappConfig(state, getters, rootState) {
    return rootState.restaurant?.locationDetails?.restaurants[0]?.restaurant_platforms?.find(
      (el) => el.platform_name === WHATSAPP.name
    );
  }
};
